export const AVAILABLE_LANGUAGES = ['de', 'en', 'es', 'fr', 'hi', 'it', 'ja', 'ko', 'pt', 'ro', 'ru', 'th', 'uk', 'zh'];
export const FALLBACK_LANGUAGE = 'pt';
export const VERSION = '2.0.13';